import React from "react";
import { Link } from "react-router-dom";
import LegalDocument from "../../components/LegalDocument/LegalDocument";

const TermsPage = () => {
  return (
    <LegalDocument title="Termos de Uso" updatedAt="18/08/2026">
      <p>
        LetsDoc — LET'S DOC TECNOLOGIA LTDA, CNPJ{" "}
        60.572.889/0001-03
      </p>

      <h2>1. Aceitação dos Termos</h2>
      <p>
        Estes Termos de Uso ("Termos") regulam o acesso e a utilização da
        plataforma LetsDoc ("Plataforma", "Serviço"), disponibilizada por{" "}
        LET'S DOC TECNOLOGIA LTDA, inscrita no CNPJ sob o nº{" "}
        60.572.889/0001-03 ("Empresa", "nós"),
        por médicos, secretárias e demais profissionais autorizados
        ("Usuário", "você").
      </p>
      <p>
        Ao criar uma conta ou utilizar a Plataforma, você declara que leu,
        compreendeu e concorda integralmente com estes Termos e com a nossa{" "}
        <Link to="/privacy-policy">Política de Privacidade</Link>. Caso não
        concorde com qualquer disposição, você não deve utilizar o Serviço.
      </p>

      <h2>2. Descrição do Serviço</h2>
      <p>
        A Plataforma é uma ferramenta de apoio administrativo e documental
        voltada a profissionais de saúde, que auxilia na elaboração de
        pedidos cirúrgicos, guias de internação, guias de OPME, resumos
        clínicos e recursos/contestações de negativas de cobertura junto a
        operadoras de saúde, além de permitir o envio desses documentos por
        e-mail a hospitais e demais destinatários cadastrados pelo próprio
        Usuário.
      </p>
      <p>
        A Plataforma pode utilizar recursos de inteligência artificial para
        sugerir procedimentos, preencher campos e apoiar a redação de
        documentos, com base nas informações fornecidas pelo Usuário.
      </p>

      <h2>3. Cadastro e Conta do Usuário</h2>
      <p>
        O acesso à Plataforma é feito mediante autenticação (login), sendo o
        Usuário responsável por manter a confidencialidade de suas
        credenciais de acesso.
      </p>
      <p>
        As informações fornecidas no cadastro (nome, CRM, especialidade,
        e-mail, entre outras) devem ser verdadeiras, completas e mantidas
        atualizadas pelo Usuário.
      </p>
      <p>
        É vedado o compartilhamento de conta entre diferentes profissionais;
        secretárias e demais colaboradores autorizados devem ser cadastrados
        através dos mecanismos próprios da Plataforma, quando disponíveis.
      </p>
      <p>
        A Empresa poderá suspender ou encerrar contas que apresentem
        indícios de uso indevido, fraude ou violação destes Termos.
      </p>

      <h2>4. Responsabilidades do Usuário</h2>
      <p>
        O Usuário é o único responsável pela exatidão, veracidade e
        legalidade das informações clínicas e administrativas inseridas na
        Plataforma, incluindo dados de pacientes, indicações cirúrgicas,
        CIDs, procedimentos e demais conteúdos gerados a partir de sua
        atuação profissional.
      </p>
      <p>O Usuário compromete-se a:</p>
      <ul>
        <li>
          Utilizar a Plataforma em conformidade com a legislação aplicável,
          incluindo as normas éticas e regulatórias do exercício da medicina
          (Código de Ética Médica, resoluções do CFM/CRM aplicáveis) e a Lei
          Geral de Proteção de Dados (Lei nº 13.709/2018 — LGPD);
        </li>
        <li>
          Manter o sigilo profissional sobre os dados de pacientes tratados
          por meio da Plataforma;
        </li>
        <li>
          Revisar e validar clinicamente todo conteúdo gerado com o auxílio
          de inteligência artificial antes de utilizá-lo, emiti-lo ou
          enviá-lo a terceiros, sendo o Usuário o único responsável pelas
          decisões clínicas e pelos documentos finais emitidos em seu nome;
        </li>
        <li>
          Não utilizar a Plataforma para fins ilícitos, fraudulentos ou que
          violem direitos de terceiros;
        </li>
        <li>
          Obter, quando aplicável, o consentimento do paciente ou base legal
          adequada para o tratamento de seus dados de saúde, sendo o Usuário
          o Controlador desses dados perante a legislação de proteção de
          dados, e a Empresa atuando como Operadora, nos termos da Seção 5 da{" "}
          <Link to="/privacy-policy">Política de Privacidade</Link>.
        </li>
      </ul>

      <h2>5. Inteligência Artificial — Limitações</h2>
      <p>
        As sugestões geradas por inteligência artificial na Plataforma têm
        caráter de apoio administrativo e documental, não constituindo
        opinião médica, diagnóstico, prescrição ou substituto do julgamento
        clínico do profissional responsável. A Empresa não se responsabiliza
        por decisões clínicas tomadas com base exclusivamente em conteúdo
        gerado automaticamente, sendo dever do Usuário revisar e validar todo
        o conteúdo antes de sua utilização.
      </p>

      <h2>6. Planos, Pagamentos e Cancelamento</h2>
      <p>
        A Plataforma poderá oferecer planos gratuitos e pagos, com
        funcionalidades e limites de uso distintos, conforme descrito na área
        de configurações da conta.
      </p>
      <p>
        Os pagamentos de planos pagos são processados por meio de provedor
        de pagamentos terceirizado (atualmente, Stripe), aplicando-se também
        os termos desse provedor.
      </p>
      <p>
        O cancelamento de assinatura pode ser realizado a qualquer momento
        pelo Usuário através do portal do cliente disponível na Plataforma,
        produzindo efeitos conforme a política de cobrança vigente no
        momento da contratação.
      </p>
      <p>
        Valores pagos não são reembolsáveis, salvo disposição legal em
        contrário ou previsão específica no plano contratado.
      </p>

      <h2>7. Propriedade Intelectual</h2>
      <p>
        Todos os direitos de propriedade intelectual relativos à Plataforma,
        incluindo software, layout, marca, logotipos e funcionalidades,
        pertencem à Empresa ou a seus licenciantes, sendo vedada a
        reprodução, engenharia reversa, distribuição ou exploração comercial
        não autorizada.
      </p>
      <p>
        Os documentos e conteúdos gerados pelo Usuário a partir de dados por
        ele inseridos (pedidos cirúrgicos, resumos, recursos etc.) pertencem
        ao próprio Usuário/paciente, sendo a Empresa mera prestadora de
        infraestrutura tecnológica para sua elaboração e armazenamento.
      </p>

      <h2>8. Limitação de Responsabilidade</h2>
      <p>
        Na máxima extensão permitida pela legislação aplicável, a Empresa
        não se responsabiliza por:
      </p>
      <ul>
        <li>decisões clínicas tomadas pelo Usuário;</li>
        <li>
          indisponibilidades temporárias do Serviço decorrentes de
          manutenção, falhas de terceiros ou caso fortuito/força maior;
        </li>
        <li>
          uso indevido da Plataforma por parte do Usuário ou de terceiros que
          tenham acesso às suas credenciais.
        </li>
      </ul>

      <h2>9. Suspensão e Encerramento</h2>
      <p>
        A Empresa poderá suspender ou encerrar, a qualquer tempo, o acesso de
        Usuários que violem estes Termos, mediante comunicação prévia sempre
        que possível. O Usuário poderá encerrar sua conta a qualquer
        momento, observado o tratamento dos dados descrito na{" "}
        <Link to="/privacy-policy">Política de Privacidade</Link>.
      </p>

      <h2>10. Alterações nos Termos</h2>
      <p>
        Estes Termos podem ser atualizados periodicamente. Alterações
        relevantes serão comunicadas ao Usuário por e-mail e/ou aviso na
        Plataforma, com indicação da nova data de vigência. O uso continuado
        do Serviço após a alteração implica concordância com os novos
        termos.
      </p>

      <h2>11. Legislação Aplicável e Foro</h2>
      <p>
        Estes Termos são regidos pelas leis da República Federativa do
        Brasil. Fica eleito o foro da comarca de{" "}
        Rio de Janeiro/RJ para dirimir quaisquer
        controvérsias decorrentes destes Termos, com renúncia a qualquer
        outro, por mais privilegiado que seja.
      </p>
    </LegalDocument>
  );
};

export default TermsPage;
